import { request } from '../util/request'

export const nodeInfo = (params) => {
  return request({
    url: '/node/info',
    method: 'get',
    params,
  })
}
